/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".chart-content[_ngcontent-%COMP%]{height:300px}.counter-card[_ngcontent-%COMP%]{padding-top:8px;padding-bottom:8px}.counter-card[_ngcontent-%COMP%]   .time-icon[_ngcontent-%COMP%]{margin-right:16px}"];
export { styles as styles };
